/*
 * This variable is automatically overwritten during builds and releases.
 * It doesn't need to be updated manually.
 */

/**
 * GOV.UK Frontend release version
 *
 * {@link https://github.com/alphagov/govuk-frontend/releases}
 */
export const version = 'development'
